import React, { FunctionComponent, useEffect } from 'react';
import { Container, Flex, Box, Heading, Divider } from '@chakra-ui/react';
import Layout from '../../components/Layout';
import { IPropsJobDetails } from '../../types/jobsTypes';
import JobAsideMenu from '../../components/jobs/JobAsideMenu';
import JobDetailDescription from '../../components/jobs/JobDetailDescription';
import JobBenefits from '../../components/jobs/JobBenefits';
import OgImage from '../../images/linkedin-image.png';

declare global {
  interface Window {
    Grnhse: {
      Iframe: {
        load: Function;
      };
    };
  }
}

const addExternalScript = (url: string, callback: () => void) => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  script.onload = callback;
  document.body.appendChild(script);
};

const JobDetails: FunctionComponent<IPropsJobDetails> = ({ pageContext }) => {
  const { id, title, description, office, department } = pageContext;

  useEffect(() => {
    addExternalScript(
      'https://boards.greenhouse.io/embed/job_board/js?for=hover',
      () => {
        window.Grnhse.Iframe.load(id);
      },
    );
  }, [id]);

  return (
    <Layout
      title={title}
      description="Please use PDF format for resumes.
    HOVER uses patented technology making it possible for anyone with a smartphone camera to create an interactive 3D model, complete with detailed measurements and powerful design features. The data produced is extremely valuable as it generates a single source of truth for the physical world allowing for more veracity throughout the home improvement and insurance processes. We’ve found an incredibly strong product-market fit across exterior home improvement, insurance, and financial services. What&#39;s the secret sauce? Cutting edge technology, an exceptional culture, and a commitment to our values (Think. Do. Serve.).&nbsp;
    With ..."
      additionalMetadata={[
        {
          property: 'og:image',
          content: OgImage,
        },
        {
          name: 'twitter:image',
          content: OgImage,
        },
        { property: 'og:image:width', content: '972' },
        { property: 'og:image:height', content: '512' },
      ]}
    >
      <Container pt={[32, 48]} pb={[6, 24]} maxW="container.xl">
        <Flex direction={['column-reverse', 'row']}>
          <Box pt={[5, 0]} width={['100%', 1 / 4, 1 / 4]}>
            <JobAsideMenu office={office} department={department} />
            <JobBenefits />
            <Heading size="xl">Application</Heading>
            <div id="grnhse_app" />
          </Box>
          <Box width={['100%', 3 / 4, 3 / 4]} pl={[0, 0, 16]}>
            <Heading mb="4" as="h3" size="lg">
              {title}
            </Heading>
            <Divider mb="8" />
            <JobDetailDescription description={description} />
          </Box>
        </Flex>
      </Container>
    </Layout>
  );
};

export default JobDetails;
